import {
  IconButton,
  IconButtonColorEnum,
  IconSizeEnum,
  Tooltip,
  TooltipIcon,
  Typography,
} from '@acceso/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { I18nextTranslationKeys } from '@/i18n/i18next';

interface SeparatorProps {
  text?: I18nextTranslationKeys;
}

const AI_GALLERY_INSTRUCTIONS_PDF_URL =
  'https://drive.google.com/file/d/1QSuC4G48mS28Ygs5My02Wjtw-Rc23wMu/view?usp=sharing';

const Separator: React.FC<SeparatorProps> = ({ text = 'Imágenes de Referencia' }) => {
  const { t } = useTranslation();

  return (
    <div className="d-flex col mt-3 w-full items-center">
      <div className="flex items-center">
        <Typography className="ml-2 font-semibold text-text-dark-10">{t(text)}</Typography>

        <Tooltip help={t('Hacer click para acceder a indicaciones')} grow>
          <IconButton
            color={IconButtonColorEnum.NONE_DEFAULT}
            onClick={() => {
              window.open(AI_GALLERY_INSTRUCTIONS_PDF_URL);
            }}
          >
            <TooltipIcon className="text-accent-active-primary-30" size={IconSizeEnum.MD} />
          </IconButton>
        </Tooltip>
      </div>

      <div className="flex-grow border-t border-gray-300"></div>
    </div>
  );
};

export default Separator;
